import {useRef, useState} from "react";
import {ArrowUp, Eye, FileText, Link} from "react-feather";
import Wizard from "@components/wizard";
import ReferralInfo from "@src/views/referral/ReferralInfo";
import Withdrawal from "@src/views/referral/Withdrawal";
import WithdrawalHistory from "@src/views/referral/WithdrawalHistory";
import ReferralHistory from "@src/views/referral/ReferralHistory";

const WizardModern = () => {
    const [stepper, setStepper] = useState(null)
    const ref = useRef(null)
    const [loadSection, setLoadSection] = useState("account-details");

    const steps = [
        {
            id: 'account-details',
            title: 'Kode referral',
            icon: <FileText size={18} />,
            content: <ReferralInfo stepper={stepper} id={"account-details"} loadSection={loadSection}/>
        },
        {
            id: 'withdrawal-request',
            title: 'Penarikan',
            icon: <ArrowUp size={18} />,
            content: <Withdrawal stepper={stepper} id={"withdrawal-request"} loadSection={loadSection}/>
        },
        {
            id: 'withdrawal-status',
            title: 'Status penarikan',
            icon: <Eye size={18} />,
            content: <WithdrawalHistory id={"withdrawal-status"} loadSection={loadSection}/>
        },
        {
            id: 'referral-status',
            title: 'Data Referral',
            icon: <Link size={18} />,
            content: <ReferralHistory id={"referral-status"} loadSection={loadSection}/>
        }
    ]
    return (
        <div className='modern-vertical-wizard'>
            <Wizard
                type='modern-vertical'
                ref={ref}
                steps={steps}
                options={{
                    linear: false
                }}
                instance={el => setStepper(el)}
                setLoadSection={setLoadSection}
            />
        </div>
    )
}

export default WizardModern